import { Container, Loading } from '@elotech/components';
import { Entidade } from '@elotech/components';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { ModulosReactEnum } from '../../type/enum';
import { IFrame } from '../iframe';

type Props = {
  modulo: ModulosReactEnum;
};

export const getEntidadeSelector = (state: any): Entidade =>
  state.entidade?.entidade;

const UnicoConsultaDinamicaComponent: React.FC<Props> = ({ modulo }) => {
  const [loading, setLoading] = useState(true);
  const entidade = useSelector(getEntidadeSelector);

  useEffect(() => {
    window?.document?.addEventListener(
      'iframe-onInit',
      e => {
        setLoading(false);
      },
      false
    );
  }, []);

  return (
    <Container breadcrumb>
      <Loading loading={loading || !entidade?.id} />
      {entidade?.id && (
        <IFrame
          path={`/unico/consulta-de-dados-dinamica?iframe=true&filter=ativo;2;true&modulo=${modulo}&entidadeId=${entidade.id}`}
        />
      )}
    </Container>
  );
};

export { UnicoConsultaDinamicaComponent };
